import { Item } from '../../../types/interfaces';
import { findPriceForQuantity } from './findPriceForQuantity';

export function calculateCartPrices(items: Item[], APO: number = 0): Item[] {
  const maxQuantity = items.reduce((total, item) => {
    return item.do_not_count ? total : total + item.quantity;
  }, APO);

  return items.map((item) => {
    const pricePerUnit = findPriceForQuantity(item.prices, maxQuantity);

    const verificationPricePerUnit = item.verification_item
      ? findPriceForQuantity(item.verification_item.prices, item.verification_quantity)
      : 0;

    // Паспорт с 09.09.2026 входит в поверку и к датчику не продаётся: в
    // сумму он не идёт, даже если в строке корзины остался старый
    // passport_quantity (бэк гасит его при первой же записи).
    return {
      ...item,
      price: pricePerUnit,
      totalPrice:
        pricePerUnit * item.quantity +
        verificationPricePerUnit * item.verification_quantity,
      verificationPrice: verificationPricePerUnit,
      verificationTotalPrice: verificationPricePerUnit * item.verification_quantity,
    };
  });
}
